import { Cliente, ClienteXCiudad, ClienteVAM } from "../../../../views/login/cliente_login";
import { CampoValor } from "../../../../views/siniestros/siniestros_entity";

export class Carpeta {
    constructor(
        public Codigo?: number,
        public Nombre?: string,
        public CodigoCiudad?: number,
        public ClaseIcono?: string,
        public Raiz?: string,
        public Ruta?: string,
        public RutaPadre?: string,
        public Atras?: boolean,
        public NombrePadre?: string,
        public Archivos?: Archivo[],
        public CodigoCliente ?: number,
        public UniCod ?: number,
        public NombreCliente ?: string
    ) { }
}
export class Archivo {
    constructor(
        public Codigo?: number,
        public Carpeta?: number,
        public Nombre?: string,
        public Extension?: string,
        public RestoRuta?: string,
        public TipoIcono?: string,
        public Ruta?: string,
    ) { }
}

export class ConsultaCarpeta {
    constructor(
        public Masivos?: Cliente,
        public Empresa?: ClienteXCiudad,
        public Carpeta?: number,
        public CodSegmento ?: number,
        public Cedula?: string,
        public Vam?: ClienteVAM[]
    ) { }
}

export class CarpetasArchivo
{
    constructor(
    public  Carpetas ?:Carpeta[],
    public  Archivos?: Archivo[]
    ){}
}
export class BuscaArchivos
{ constructor(
    public  NombreCliente ?: string,
    public  CodigoCliente ?: number,
    public  CodigoCiudad ?: number,
    public  CodigoUnidad ?: number,
    public  Carpeta ?: number,
    public  RestoRuta ?: string,
    public  CodigoSegmento ?: number
){}

}
export class Preguntas {
    public ArqPregunta1?: string;
    public ArqPregunta2?: string;
    public lstResArq1?: CampoValor[];
    public lstResArq2?: CampoValor[];
    public ArqRes1?: number;
    public ArqRes2?: number;
}
export class Contacto {
    public Nombres?: string;
    public Apellidos?: string;
    public CedulaRuc?: string;
    public FechaNacimiento?: Date;
    public Telefono1?: string;
    public Extension?: string;
    public Telefono2?: string;
    public Cargo?: Date;
    public TipoContactoCarta?: number;
    public CodigoTipo?: number;
    public Hobby?: string;
    public UniCod?: number;
    public NombresConyuge?: string;
    public ApellidoConyuge?: string;
    public FechaNacimientoConyuge?: Date;
    public CedulaRucConyuge?: string;
    public HobbyConyuge?: string;
    public LugarTrabajoConyuge?: string;
    public NombreAgrupacion?: string;
    public CodigoAgrupacion?: number;
    public EmpRol?: number;
    public Codigo?: number;
    public CodigoCoyuge?: number;
    public DescripcionTipConCarta?: string;
    public DescripcionTipCon?: string;
    public SuscripcionBoletin?: boolean;
    public Encuestar?: boolean;
    public EnvioMailTecni?: boolean;
    public ApellidoMaterno?: string;
    public SegundoNombre?: string;
    public Sexo?: number;
    public Editado?: boolean;
    public TipoDocumento?: number;
    public lstAgrupacion?: CampoValor[];
    public lstContactoTabla?: CampoValor[];
    public lstContactoTablaCarta?: CampoValor[];
    public lstTipoSexo?: CampoValor[];
    public lstTipoDocumento?: CampoValor[];
    public NombreCliente?: string;
    public OtrasUnidades?: boolean;
    public Email?: string;
    public Profesion?: string;
    public lstRamos?: CampoValor[];
    public Editar?: boolean;
    public Nuevo?: boolean;
    public CliCod?: number;
    public CiuCod?: number;
    public Mensaje?: string;
    public Eliminar?: boolean;
    //public Telefonos?: Telefono[];
    public lstProfesion?: CampoValor[];
    public CodigoProfesion?: number;
    //public lstHobby?: Hobby[];
    public hobbies?: number[];
    public Asignar?: boolean;
    public lstCargo?: CampoValor[];
    public CodigoCargo?: number;
    //public lstEmails?:Email[];
    public lstEstadoCivil?:CampoValor[];
    public CodigoEstadoCivil?:number;
    public CodigoClienteUnico?:number;
    public AsignarUnidad?:boolean;
    public Arquetipo?:number;
    public lstarquetipos?: CampoValor[];
    public ArqRes1?:number;
    public ArqRes2?:number;
    public preguntas:Preguntas;
    public conclicod?: number;

}

export class PreguntasSAES {
    public Descripcion?: string;
    public Codpregunta?:number;
    public IdSiniestro?:number;
    public res1?:boolean;
    public res2?:boolean;
    public res3?:boolean;
    public res4?:boolean;
    public res5?:boolean;
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/utils/entities/util_entity.ts